import { DataElement } from '../interfaces/PhysiologicalMonitoring';
import { Parameter } from '../interfaces/Profile';

export const cssvar = (name: string) =>
    getComputedStyle(document.documentElement).getPropertyValue(name);


export const groupDataByType = (elements: DataElement[] | undefined, types: string[]) => {
    if (elements === undefined || elements.length === 0)
        return [];
    return types.map(type =>
        elements.filter(timestamp => timestamp.values[type] !== undefined).reverse()
    );
};


const calcularDataSeries = (fisiological_monitoring: DataElement[], param_id: string) =>
    fisiological_monitoring.map(valuesDate => valuesDate.values[param_id]);

export const getSeriesByType = (parameter: Parameter, data: DataElement[][]): any => {

    const markPoint = {
        symbol: 'circle',
        symbolSize: 9,
        label: { show: false },
        data: [
            {
                name: 'maximum',
                type: 'max'
            },
            {
                name: 'minimum',
                type: 'min',
            },
        ],
        animationDelay: 500
    };
    const minLimitLine = parameter.min_limit ? {
        name: 'low-alert',
        symbol: 'none',
        yAxis: parameter.min_limit,
        lineStyle: {
            color: 'rgba(0,0,255)',
            type: 'solid',
            width: 1,
            opacity: 0.3
        }
    } : undefined;
    const maxLimitLine = parameter.max_limit ? {
        name: 'high-alert',
        symbol: 'none',
        yAxis: parameter.max_limit,
        lineStyle: {
            color: 'rgba(255,0,0)',
            type: 'solid',
            width: 1,
            opacity: 0.3
        }
    } : undefined;
    return {
        data: calcularDataSeries(data[0], parameter.id),
        type: 'line',
        connectNulls: true,
        color: parameter.color,
        name: parameter.name,
        markPoint: markPoint,
        markLine: {
            symbol: 'none',
            data: [minLimitLine, maxLimitLine].filter(l => l !== undefined),
            label: {
                position: 'end',
                fontSize: 13,
                fontWeight: 500
            },
            emphasis: {
                lineStyle: {
                    opacity: 1,
                    type: 'solid',
                    width: 1,
                }
            }
        }
    };
};
